// TODO: Add all route types here

export interface AbsencesRouteParams {
  year: string
  month: string
}

export interface EmployeesRouteParams {
  id: string
  year?: string
  path?: string
}

export enum EmployeeSettingsRoutes {
  EmployeeDetail = "employee-details",
  ContractDetail = "contract-details",
  LeaveEntitlementsDetail = "leave-and-absences",
  PersonalAbsences = "personal-absences",
}

export enum PracticeSettingsRoutes {
  WorkingHours = "working-hours",
  General = "general",
  HrConfiguration = "hr-configuration",
  ClosingDays = "closing-days",
}
